var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-radio-text"},_vm._l((_vm.list),function(item){return _c('span',{key:item[_vm.valueKey],class:{
      'v-radio-text__item': true,
      'v-radio-text__item--active': item[_vm.valueKey] === _vm.value,
    },on:{"click":function($event){$event.stopPropagation();return (function () { return _vm.chooseItem(item[_vm.valueKey]); })($event)}}},[_vm._v("\n    "+_vm._s(item[_vm.labelKey])+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }